import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import Showcase from "@/components/Showcase";
import HeaderVideo from "@/components/HeaderVideo";

const path = window.location.pathname;
const isShowcase = path.startsWith("/showcase");
const isHeaderVideo = path.startsWith("/header-video");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {isHeaderVideo ? <HeaderVideo /> : isShowcase ? <Showcase /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);
